module.exports = __webpack_public_path__ + "36b53ba3158fc8959435ceaf2998b23b.pdf";